/* eslint-disable filenames/match-exported */
import Fetch from './src/Fetch';

export default Fetch;
